export function clamp(value: number, min: number, max: number): number {
  return Math.min(Math.max(value, min), max);
}

function containCover(
  item: { width: number; height: number },
  container: { width: number; height: number },
  isContain: boolean
): { width: number; height: number } {
  const itemRatio = item.height / item.width; // original item ratio
  const containerRatio = container.height / container.width; // container ratio

  let finalWidth = 0; // the scaled img width
  let finalHeight = 0;

  const selection = isContain
    ? containerRatio < itemRatio
    : containerRatio > itemRatio;

  if (selection) {
    finalHeight = container.height;
    finalWidth = container.height / itemRatio;
  } else {
    finalWidth = container.width;
    finalHeight = container.width * itemRatio;
  }

  return { width: finalWidth, height: finalHeight };
}

export function contain(
  item: { width: number; height: number },
  container: { width: number; height: number }
): { width: number; height: number } {
  return containCover(item, container, true);
}

export function cover(
  item: { width: number; height: number },
  container: { width: number; height: number }
): { width: number; height: number } {
  return containCover(item, container, false);
}